import { Component, OnInit, ElementRef, ViewChildren } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { UserService } from '../../_services/user.service';
import { MatDialog } from '@angular/material';
import { SaveMessageComponent } from '../../directive/save-message/save-message.component';
import { HttpClient } from '@angular/common/http';
import { Http, Headers } from '@angular/http';
import { AngularFirestore } from 'angularfire2/firestore';

@Component({
  selector: 'app-import-contacts',
  templateUrl: './import-contacts.component.html',
  styleUrls: ['./import-contacts.component.css']
})
export class ImportContactsComponent implements OnInit {
  auth2: any;
  @ViewChildren("google") googleButton: ElementRef;
  emailSent: Boolean;
  userId = localStorage.getItem("currentUserId");
  subsSendMail: Subscription;
  friend: FormGroup;
  private subscription: Subscription = new Subscription();
  user: any;
  isMobile = false;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private userService: UserService,
    private httpclient: HttpClient,
    private afs: AngularFirestore,
    public dialog: MatDialog) {

    this.friend = fb.group({
      email: ["", Validators.compose([Validators.required, Validators.email])],
      name: ['', Validators.required]
    });
    this.isMobile = window.matchMedia("(max-width: 1024px)").matches;
    this.subscription.add(this.userService.getUser().subscribe(user => {
      this.user = user;
    }));
  }

  ngOnInit() {

  }


  sendEmail() {
    if (!this.userId) {
      this.router.navigate(['/auth']);
      return;
    }
    if (this.user) {

      this.userService.sendEmail({
        type: "InviteFriend",
        nameTo: this.friend.value.name,
        nameFrom: this.user.firstname + " " + this.user.lastname,
        email: this.friend.value.email,
        userId: this.userId
      }).then(() => {
        this.getPoint();
        const option = {
          data: {
            customToken: this.userId,
            email: this.friend.value.email,
            nameTo: this.friend.value.name,
            nameFrom: this.user.firstname + " " + this.user.lastname
          }
        }
        this.friend = this.fb.group({
          email: [""],
          name: ['']
        });

        this.request(option);


      })

    }
  }
  request(option) {

    const sub = this.httpclient.post('https://api.bigadvice.com/email/sendInviteFriend', option.data)
      .subscribe((res) => {
        if (res === "OK") {
          sub.unsubscribe();
        }
      });
  }
  getPoint() {

    const userInfoPoints = this.user.userInfoPoints;
    let point;
    let totalPoint = 0;

    if (userInfoPoints.importContact == 0) {

      point = 10;
      let update = {};
      this.afs.collection('users').doc(this.userId).update({
        userInfoPoints: {
          importContact: point
        }
      }).then(() => {
        this.afs.collection('users').doc(this.userId).ref.get().then((data) => {
          this.afs.collection('users').doc(this.userId).update({
            point: {
              totalPoint: data.data().point.totalPoint ? data.data().point.totalPoint + 10 : 10
            }
          })
        })

      })
        .then(() => {
          let userPoint;
          if (this.user) {
            userPoint = this.user.point ? this.user.point.totalPoint : 0;
          }
          totalPoint = userPoint + 10;
          this.dialog.open(SaveMessageComponent, {
            width: '400px',
            data: {
              message: "Davetin arkadaşına iletildi. Tebrikler " + point + " puan kazanarak " + totalPoint + " puana yükseldin.",
              type: "update"
            }
          });
        });
    } else {
      this.dialog.open(SaveMessageComponent, {
        width: '400px',
        data: {
          message: "Davetin arkadaşına iletildi.",
          type: "update"
        }
      });
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/profile-update/import-contacts/import-contacts.component.ts